import * as React from "react";
import { ProcessingStatusType } from "../../types/nlsTypes";
import {
  //ClubDetail,
  PyramidDetailsState,
  PyramidDetailsAction,
  ClubPyramidStatusType,
} from "../../types/pyramid/pyramidTypes";

const initialPyramidDetailsState: PyramidDetailsState = {
  pyramidDetails: null,
  pyramidDetailsStatus: ProcessingStatusType.pending,
  selectedPyramidId: null,
  clubPyramidUpdateStatus: ClubPyramidStatusType.ok,
};

export const PyramidContext = React.createContext<{
  state: PyramidDetailsState;
  dispatchPyramidDetail: React.Dispatch<PyramidDetailsAction>;
}>({
  state: initialPyramidDetailsState,
  dispatchPyramidDetail: () => undefined,
});
